/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_Column_TypeInputs */

const en_knp_terms_column_type = /** @type {(inputs: Knp_Terms_Column_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const fr_knp_terms_column_type = /** @type {(inputs: Knp_Terms_Column_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const de_knp_terms_column_type = /** @type {(inputs: Knp_Terms_Column_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ`)
};

const it_knp_terms_column_type = /** @type {(inputs: Knp_Terms_Column_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

const ru_knp_terms_column_type = /** @type {(inputs: Knp_Terms_Column_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип`)
};

const es_knp_terms_column_type = /** @type {(inputs: Knp_Terms_Column_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

const zh_cn2_knp_terms_column_type = /** @type {(inputs: Knp_Terms_Column_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`类型`)
};

const ja_knp_terms_column_type = /** @type {(inputs: Knp_Terms_Column_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイプ`)
};

const hi_knp_terms_column_type = /** @type {(inputs: Knp_Terms_Column_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रकार`)
};

const pt_pt2_knp_terms_column_type = /** @type {(inputs: Knp_Terms_Column_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

/**
* | output |
* | --- |
* | "Type" |
*
* @param {Knp_Terms_Column_TypeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_column_type = /** @type {((inputs?: Knp_Terms_Column_TypeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Column_TypeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_terms_column_type(inputs)
	if (locale === "de") return de_knp_terms_column_type(inputs)
	if (locale === "it") return it_knp_terms_column_type(inputs)
	if (locale === "ru") return ru_knp_terms_column_type(inputs)
	if (locale === "es") return es_knp_terms_column_type(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_terms_column_type(inputs)
	if (locale === "ja") return ja_knp_terms_column_type(inputs)
	if (locale === "hi") return hi_knp_terms_column_type(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_terms_column_type(inputs)
	return en_knp_terms_column_type(inputs)
});